<template>
    <div class="content">
        <h2 class="h2">{{ t('title') }}</h2>
        <p>{{ t('text1') }}</p>
        <p>{{ t('text2') }}</p>
        <DSInput
            v-model="order.data.value.food"
            :label="t('food')"
            :help-text="t('required')"
            :error="order.errors.value.food"
        />
        <DSInput
            v-model="order.data.value.allergies"
            :label="t('allergies')"
            :error="order.errors.value.allergies"
            :help-text="t('required')"
        />
    </div>
</template>
<script setup>
import { inject, useI18n } from '#imports';

const order = inject('order');

defineOptions({
    inheritAttrs: false,
});

defineProps({
    stepTitle: {
        type: String,
        required: false,
        default: '',
    },
});

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            title: 'Mitä haluaisitte tilata?',
            text1: 'Kirjoita alle, mitä ruokatuotteita toivotte ryhmätilaukseen. Tarkennathan onko kyseessä kahvituotteet (makeat ja suolaiset kahvileivät), päivän noutopöytä, buffetruokailu lounasajan jälkeen tai a la carte -listalta tilatut ruoat. Huomioithan, että ryhmätilaus edellyttää yhtenäistä menuvalintaa (erikoisruokavaliot huomioidaan)',
            text2: 'Ryhmätilauksissa on asemakohtaisia eroja ja tarvittaessa asema ehdottaa muutoksia tilaukseenvahvistusvaiheessa.',
            food: 'Ruokatoive',
            allergies: 'Allergiat / erikoisruokavaliot',
        },
        'en-EU': {
            title: 'Mitä haluaisitte tilata?',
            text1: 'Kirjoita alle, mitä ruokatuotteita toivotte ryhmätilaukseen. Tarkennathan onko kyseessä kahvituotteet (makeat ja suolaiset kahvileivät), päivän noutopöytä, buffetruokailu lounasajan jälkeen tai a la carte -listalta tilatut ruoat. Huomioithan, että ryhmätilaus edellyttää yhtenäistä menuvalintaa (erikoisruokavaliot huomioidaan)',
            text2: 'Ryhmätilauksissa on asemakohtaisia eroja ja tarvittaessa asema ehdottaa muutoksia tilaukseenvahvistusvaiheessa.',
            food: 'Ruokatoive',
            allergies: 'Allergiat / erikoisruokavaliot',
        },
    },
});
</script>
<style scoped>
.message {
  font-size: 0.75rem;
  color: var(--color-base-grey-600);
  margin-bottom: 1rem;
}
</style>
